import client from './client.js';

// POST /api/cfdi/emitir
// receptor: { rfc, razon_social, codigo_postal, regimen_fiscal?, uso_cfdi? }
// Los conceptos NO se mandan: el servidor los saca de la venta. Mandarlos
// haría creer que el cliente decide qué se factura, y no decide.
// Tampoco la forma de pago: la dice la venta. Con la cuenta dividida se declara
// la predominante, que el cliente no puede saber desde una sola parte.
//
// Devuelve la factura y, si la hubo, la nota de crédito que se emitió antes:
// cuando la venta ya estaba declarada en la factura global, el servidor la saca
// de ahí con un egreso para no declararla dos veces. Quien factura tiene que
// saberlo — salieron dos comprobantes, no uno.
export const emitirFactura = ({ receptor, pos_payment_id }) =>
  client.post('/cfdi/emitir', { receptor, pos_payment_id })
    .then((r) => ({
      ...r.data.data,
      // Con una cuenta dividida puede haber una por cada parte; los servidores
      // anteriores solo mandaban la primera.
      notas_credito: r.data.notas_credito ?? (r.data.nota_credito ? [r.data.nota_credito] : []),
    }));
